<template>
  <div>
    <az-back-button :route="{name: 'documentosVirtualizacao', params: {id: licitacaoId}}" text="Voltar para os documentos"></az-back-button>
    <div class="az-form-content" style="padding-bottom: 200px">
      <v-container fluid grid-list-xl>
        <v-layout d-flex wrap align-center class="mx-2 pt-2 justify-start">
          <v-flex class="az-text pb-0 pt-0 mb-0" xs6 sm4 md3>
            <div class="az-text">
              <label>Número do Processo</label>
              <p class="pb-0 mb-0">{{licitacao.numProcesso}}</p>
            </div>
          </v-flex>
          <v-flex class="az-text pb-0 pt-0 mb-0" xs6 sm4 md3>
            <div class="az-text">
              <label>Documento</label>
              <p v-if="documento" class="pb-0 mb-0">{{documento.nome}}</p>
              <p v-else><strong>--</strong></p>
            </div>
          </v-flex>
          <v-flex class="az-text pb-0 pt-0 mb-0" xs6 sm4 md3>
            <div class="az-text">
              <label>Páginas do Documento</label>
              <p v-if="documento" class="pb-0 mb-0">De <strong>{{documento.primeiraPagina}}</strong> até <strong>{{documento.ultimaPagina}}</strong></p>
              <p v-else><strong>--</strong></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <br>
      <v-divider></v-divider>
      <v-container fluid grid-list-xl>
        <v-layout d-flex wrap align-center class="mx-2 pt-2 justify-start">
          <v-flex class="az-text" xs12 sm8 md6 >
            <v-layout>
              <v-flex xs12 sm8 md8 class="pb-0 pt-0">
                <label class="label">Modelo de documento</label>
                <v-select :items="modelos" item-value="html" item-text="descricao" name="Modelo"
                          v-model="modeloSelecionado" :menu-props="{ top: false, offsetY: true}"
                          placeholder="Selecione" no-data-text="Nenhum modelo encontrado">
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout align-center class="az-text ml-2 justify-start">
          <v-flex xs12 sm12 md12 class="pb-0 pt-0">
            <label class="label">Conteúdo</label>
          </v-flex>
        </v-layout>
        <v-layout align-center class="az-text justify-start">
          <v-flex xs12 sm12 md12 class="pt-0">
            <tiny-editor v-if="documentoVirtualizadoId" class="pt-2" :modelo="modeloSelecionado"></tiny-editor>
          </v-flex>
        </v-layout>
        <div class="az-actions-form">
          <button class="action-secundary-button cancelar-desentranhar" @click="$router.push({name: 'documentosVirtualizacao', params: {id: licitacaoId}})">Cancelar</button>
          <button class="action-primary-button" @click.prevent="desentranhar">Salvar</button>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import TinyEditor from "@/views/licitacao/detalhe/commons/TinyEditor";
import {actionTypes, mutationTypes, situacoesDocumentosVirtualizados} from "@/commons/constants";

export default {
  name: 'Desentranhamento',
  components: {
    TinyEditor,
  },
  inject: ['$validator'],
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      situacoesDocumentosVirtualizados,
      licitacaoId: null,
      documentoVirtualizadoId: null,
      documento: null,
      modeloSelecionado: null,
      paginas: {
        inicio: null,
        fim: null
      },
      modelos:[]
    }
  },
  computed: {
    ...mapState(['licitacao', 'documentosVirtualizados'])
  },
  async mounted() {
    try {
      this.setLicitacaoId()
      await this.buscarLicitacao()
      await this.buscarDocumentoVirtualizado()
      await this.buscarModelosDocumento()
    } catch (e) {
      this.mostrarNotificacaoErro(e.message)
    }
  },
  methods: {
    async buscarDocumentoVirtualizado(){
      if(!this.documentosVirtualizados || this.documentosVirtualizados.length < 1){
        this.habilitarLoadingGlobal()
        this.setMensagemLoading("Carregando dados do documento...")
        const data = await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_LICITACAO,
            {
              licitacaoId: this.licitacaoId,
              paginacao: {page:1, rowsPerPage:10},
              filtros: {situacao: 'JUNTADO'}
            }
        )
        const {paginacaoDocumentos} = data
        this.$store.commit(mutationTypes.SET_DOCUMENTOS_VIRTUALIZADOS, paginacaoDocumentos.content)
      }
      this.documento = this.documentosVirtualizados.find(doc => doc.documentoVirtualizadoId === this.documentoVirtualizadoId)
    },
    async buscarLicitacao(){
      this.habilitarLoadingGlobal()
      this.setMensagemLoading("Carregando dados da licitação...")
      await this.$store.dispatch(actionTypes.BUSCAR_LICITACAO, this.licitacaoId)
    },
    async buscarModelosDocumento(){
      this.habilitarLoadingGlobal()
      this.setMensagemLoading("Buscando modelos de documentos...")
      const resposta = await this.$store.dispatch(actionTypes.BUSCAR_MODELOS_DESENTRANHAMENTO, this.licitacaoId)
      // this.modelos.push({descricao:'Nenhum', html:''})
      this.modelos.push(...resposta.modelosTermoDesentranhar)
      if(this.modelos.length === 1){
        this.modeloSelecionado = this.modelos[0]
      }
    },
    async desentranhar(){
      const myContent = tinymce.activeEditor.getContent();
      if(myContent.length === 0){
        this.mostrarNotificacaoErro("O documento está vazio. Selecione um modelo ou digite o conteúdo.")
        return;
      }
      const payload = {
        licitacaoId: this.licitacaoId,
        documentoId: this.documento.documentoId,
        documentoVirtualizadoId: this.documento.documentoVirtualizadoId,
        tipoDocumento: this.documento.tipo,
        termoHtml: myContent
      }
      const resposta = await this.$store.dispatch(actionTypes.FLOWBEE.DESENTRANHAR_DOCUMENTO, payload)
      this.mostrarNotificacaoSucesso("Termo de Desentranhamento criado com sucesso.")
      await this.$router.push({name: 'documentosVirtualizacao', params: {id: this.licitacaoId}})
    },
    setLicitacaoId() {
      this.licitacaoId = this.$route.params.id
      this.documentoVirtualizadoId = this.$route.params.documentoVirtualizadoId
    },
  }
}
</script>
<style lang="stylus">
.v-select
  padding-top 0 !important
  margin-top 0 !important

.cancelar-desentranhar
  border 1px solid grey
  border-radius 2px
</style>
